import React from 'react'
import { graphql, ChildProps } from 'react-apollo'
import gql from 'graphql-tag'
import Warning from 'material-ui/svg-icons/alert/warning'
import styled from '../../../theme/styled'
import format from 'date-fns/format'

const KnownIssuesWrapper = styled.div`
  margin: 20px 0;
  padding: 20px;
  background: rgba(0, 0, 0, 0.1);

  h4 {
    margin-bottom: 10px;
    display: flex;
    align-items: center;

    svg {
      margin-right: 10px;
    }
  }

  ul {
    list-style: disc;
    padding-left: 20px;
  }

  li {
    font-size: 14px;
    margin-bottom: 5px;
  }
`

type Content = {
  html: string
  updatedAt: string
}

type ContentResponse = { content: Content | null }

function KnownIssues(props: ChildProps<{}, ContentResponse>) {
  // TODO: remove (react-apollo: 2.1.x)
  if (!props.data) {
    return null
  }

  if (props.data.loading) {
    return <div>Loading</div>
  }

  if (!props.data.content) {
    return null
  }

  const updatedAt = format(props.data.content.updatedAt, 'MMM YYYY')

  return (
    <KnownIssuesWrapper>
      <h4>
        <Warning color="white" /> BETA version -<br /> known issues {updatedAt}
      </h4>
      <ul dangerouslySetInnerHTML={{ __html: props.data.content.html }} />
    </KnownIssuesWrapper>
  )
}

const QUERY = gql`
  query ContentKnownIssuesQuery {
    content(key: "known_issues") {
      html
      updatedAt
    }
  }
`

export default graphql<ContentResponse>(QUERY)(KnownIssues)



// WEBPACK FOOTER //
// ./src/Components/Layout/Features/KnownIssues.tsx